/**
 * Fire a GA4 event through the gtag bootstrap SiteAnalytics injects into
 * <head>. Safe no-op during SSR and on sites with ga4:null (no bootstrap, so
 * window.gtag is absent). When a content blocker strips the gtag.js loader
 * the bootstrap stub still exists and queues harmlessly.
 */
export function gaEvent(name, params) {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') {
    return;
  }
  window.gtag('event', name, params);
}
